"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var spaui_1 = require("@tencent/spaui");
var odc_flex_1 = __importDefault(require("@tencent/odc-flex"));
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
var odc_titlebar_1 = __importDefault(require("@tencent/odc-titlebar"));
var Accordion_1 = require("./Accordion");
var AccordionPanel = function AccordionPanel(props) {
  var _a, _b, _c;
  var _d = props.showArrow,
    showArrow = _d === void 0 ? true : _d,
    onItemClick = props.onItemClick,
    _e = props.panelKey,
    panelKey = _e === void 0 ? '' : _e,
    header = props.header,
    extra = props.extra,
    children = props.children,
    isActive = props.isActive,
    activeArrowPrefix = props.activeArrowPrefix,
    notActiveArrowPrefix = props.notActiveArrowPrefix,
    _f = props.triggerTarget,
    triggerTarget = _f === void 0 ? 'header' : _f,
    arrowProps = props.arrowProps,
    _g = props.headerTitleSize,
    headerTitleSize = _g === void 0 ? 5 : _g,
    scrollIntoView = props.scrollIntoView,
    panelProps = props.panelProps,
    headerProps = props.headerProps,
    headerClassName = props.headerClassName,
    bodyProps = props.bodyProps,
    bodyClassName = props.bodyClassName,
    frontOfBodyContent = props.frontOfBodyContent,
    endOfBodyContent = props.endOfBodyContent;
  var panelRef = (0, react_1.useRef)();
  var handleItemClick = function handleItemClick() {
    if (typeof onItemClick === 'function') {
      onItemClick(panelKey);
      setTimeout(function () {
        if (scrollIntoView && panelRef && panelRef.current !== undefined) {
          panelRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      }, 0);
    }
  };
  return react_1["default"].createElement(odc_frame_1["default"], __assign({}, panelProps, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])("".concat(Accordion_1.PREFIX_CLS, "-panel"), (_a = {}, _a["".concat(Accordion_1.PREFIX_CLS, "-panel-active")] = isActive, _a)),
    supportAllEvents: true
  }, AccordionPanel), {
    htmlRef: panelRef
  }), react_1["default"].createElement(odc_flex_1["default"], __assign({}, headerProps, {
    className: (0, classnames_1["default"])("".concat(Accordion_1.PREFIX_CLS, "-header"), headerClassName, (_b = {}, _b["".concat(Accordion_1.PREFIX_CLS, "-hide-arrow")] = !showArrow, _b["".concat(Accordion_1.PREFIX_CLS, "-header-active")] = isActive, _b)),
    onClick: triggerTarget === 'header' ? handleItemClick : undefined
  }), react_1["default"].createElement(odc_titlebar_1["default"], {
    size: headerTitleSize,
    className: "".concat(Accordion_1.PREFIX_CLS, "-header-title"),
    title: header
  }), extra, showArrow && react_1["default"].createElement(odc_flex_1["default"], __assign({
    itemsCenter: true,
    gap: "4",
    color: "var(--odc-gray-02)",
    onClick: triggerTarget === 'arrow' ? handleItemClick : undefined
  }, arrowProps), isActive ? activeArrowPrefix : notActiveArrowPrefix, react_1["default"].createElement(spaui_1.Icon, {
    name: "dropdown-arrow-outlined",
    className: "".concat(Accordion_1.PREFIX_CLS, "-header-arrow")
  }))), frontOfBodyContent, react_1["default"].createElement(spaui_1.Transition, {
    transitionName: "slide-up",
    component: "",
    showProp: "data-show"
  }, react_1["default"].createElement(odc_frame_1["default"], __assign({}, bodyProps, {
    "data-show": isActive,
    className: (0, classnames_1["default"])("".concat(Accordion_1.PREFIX_CLS, "-body"), bodyClassName, (_c = {}, _c["".concat(Accordion_1.PREFIX_CLS, "-body-active")] = isActive, _c)),
    style: {
      display: !isActive ? 'none' : undefined
    }
  }), children)), endOfBodyContent);
};
exports["default"] = react_1["default"].memo(AccordionPanel);